import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import ProjectSettingsModal from '../components/ProjectSettingsModal';

const mapStateToProps = state => {
  const users = selectors.selectUsersForCurrentOrganization(state);
  const currentUser = selectors.selectCurrentUser(state);

  const { id, name, background, backgroundImage, isBackgroundImageUpdating } =
    selectors.selectCurrentProject(state);

  const managers = selectors.selectManagersForCurrentProject(state);

  return {
    id,
    name,
    background,
    backgroundImage,
    isBackgroundImageUpdating,
    managers,
    allUsers: users,
    organizationId: currentUser ? (typeof currentUser.organizationId === 'object' ? currentUser.organizationId.id : currentUser.organizationId) : null,
  };
};

const mapDispatchToProps = (dispatch) => {
  const actions = bindActionCreators(
    {
      onUpdate: entryActions.updateCurrentProject,
      onBackgroundImageUpdate: entryActions.updateCurrentProjectBackgroundImage,
      onDelete: entryActions.deleteCurrentProject,
      onManagerCreate: entryActions.createManagerInCurrentProject,
      onManagerDelete: entryActions.deleteProjectManager,
      onClose: entryActions.closeModal,
      syncOrganizationFromClerk: entryActions.syncOrganizationFromClerk,
    },
    dispatch,
  );

  return {
    ...actions,
    onSync: (organizationId) => actions.syncOrganizationFromClerk(organizationId),
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onSync: () => dispatchProps.onSync(stateProps.organizationId),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ProjectSettingsModal);
